import actionTypes from "../actionTypes";

export const FETCH_PAYMENTS = actionTypes("FETCH_PAYMENTS");
export const GENERATE_PAYMENT_LINK = actionTypes("GENERATE_PAYMENT_LINK");
export const CLEAR_PAYMENT_LINK = "CLEAR_PAYMENT_LINK";
export const RESOLVE_PAYMENT = actionTypes("RESOLVE_PAYMENT");
